import { SIZES as TEXT_SIZES } from '../Typography/constants'

export const SIZES = {
  MEDIUM: 'Medium',
  SMALL: 'Small',
} as const

export const TEXT_MAP = {
  [SIZES.MEDIUM]: TEXT_SIZES.S,
  [SIZES.SMALL]: TEXT_SIZES.XS,
} as const

export const RADIO_DISPLAY_NAME = 'Radio'
export const RADIO_BUTTON_DISPLAY_NAME = 'Radio.Button'
export const RADIO_GROUP_DISPLAY_NAME = 'Radio.Group'
export const RADIO_FOOTER_DISPLAY_NAME = 'Radio.Footer'
export const RADIO_HEADER_DISPLAY_NAME = 'Radio.Header'

export const KIND = {
  DEFAULT: 'Default',
  SELECT: 'Select',
  OPTION: 'Option',
} as const

export const ICON = {
  DEFAULT: 'Default',
  SELECT: 'Select',
} as const

export const POLYLINE_MAP = {
  [SIZES.MEDIUM]: '6.5,13.5 10,17 18,8.5',
  [SIZES.SMALL]: '4.3,9 6.67,11.33 12,5.67',
} as const

export const VIEWBOX_MAP = {
  [SIZES.MEDIUM]: '0 0 24 24',
  [SIZES.SMALL]: '0 0 16 16',
} as const

export const LABEL_WIDTH = {
  DEFAULT: 'Default',
  FULL: 'Full',
} as const

export const LABEL_PLACEMENT = {
  TOP: 'Top',
  MIDDLE: 'Middle',
} as const
